import * as React from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router";
import { DetailLayoutWrapper } from "../../components/sharedStyles";
import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import useActiveFilters from "../../hooks/useActiveFilters";
import { StatusLabel } from "../../components/Lists/Base/CompleteList/styles";
import { PopupButton } from "../../components/Forms/Base/Buttons";
import { usePermissionCheck } from "../../store/base";
import { createUrl as createParkingSpotUrl } from "../../store/parkingSpots/utils";
import { createUrl as createParkingLotUrl } from "../../store/parkingLots/utils";
import { useParkingLotsPaginationCount } from "../../store/parkingLots/hooks/retrieve";
import { useParkingSpotsPaginationCount } from "../../store/parkingSpots/hooks/retrieve";
import ParkingLots from "./overview/ParkingLots";
import ParkingSpots from "./overview/ParkingSpots";
import usePermissionRedirect from "../../hooks/usePermissionRedirect";
import ParkingSpotCancellations from "./overview/ParkingCancellations";
import ParkingSpecifications from "./overview/Specifications";

export default function MainParkingOverview() {
  const { path, url } = useRouteMatch();
  const { push } = useHistory();
  const { filteredRealEstates } = useActiveFilters();
  usePermissionRedirect(["view_can_parking"]);

  const canAddParking = usePermissionCheck("add_can_parking");

  let actions = [];

  if (canAddParking) {
    actions = [
      {
        name: "Parkeringsområde",
        onClick: () => push(createParkingLotUrl()),
      },
      {
        name: "Fordonsplats",
        onClick: () => push(createParkingSpotUrl()),
      },
    ];
  }

  const [parkingLotCount, parkingLotCountLoading] =
    useParkingLotsPaginationCount({
      realEstates: filteredRealEstates,
    });
  const [parkingSpotCount, parkingSpotCountLoading] =
    useParkingSpotsPaginationCount({
      realEstates: filteredRealEstates,
    });

  const SUB_PAGES = [
    {
      path: "/parking-lots",
      label: "Parkeringsområden",
      component: ParkingLots,
    },
    {
      path: "/parking-spots",
      label: "Fordonsplatser",
      component: ParkingSpots,
    },
    {
      path: "/parking-specifications",
      label: "Specifikationer",
      component: ParkingSpecifications,
    },
    {
      path: "/parking-spot-cancellations",
      label: "Uppsägningsöversikt",
      component: ParkingSpotCancellations,
    },
  ];

  const subPageLinks = SUB_PAGES.map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
    hasError: sp.hasError,
  }));

  const renderInfoPills = () => {
    return (
      <>
        <StatusLabel state={0}>
          Antal parkeringsområden:{" "}
          {parkingLotCountLoading ? "Laddar..." : parkingLotCount ?? 0}
        </StatusLabel>
        <StatusLabel style={{ marginLeft: 12 }} state={5}>
          Antal fordonsplatser:{" "}
          {parkingSpotCountLoading ? "Laddar..." : parkingSpotCount ?? 0}
        </StatusLabel>
      </>
    );
  };

  const renderActions = () => (
    <>
      {actions?.length > 0 && (
        <PopupButton leftAligned title="Lägg till..." actions={actions} />
      )}
    </>
  );

  return (
    <>
      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Parkeringar`}
          {...{ subPages: subPageLinks, renderInfoPills, renderActions }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}
